import React, { useState } from 'react';
import { Card, Form, InputGroup } from 'react-bootstrap';
import Button from '../../../../../components/button';
import { useNamespacedTranslation } from '../../../../../hooks/useNamespacedTranslation';

type Props = {
  onApplyMeritToAll: (meritPercent: number) => void;
};

// "Apply a single merit % across every row" control: a slim card sitting
// directly above the items table.
export const ApplyMeritControl: React.FC<React.PropsWithChildren<Props>> = ({
  onApplyMeritToAll,
}) => {
  const t = useNamespacedTranslation('compensationReviews.toolbar');
  const [merit, setMerit] = useState('');

  return (
    <Card className="mb-4">
      <Card.Body>
        <div className="compensation-merit-title mb-2">{t('applyMerit')}</div>
        <div className="d-flex align-items-stretch gap-2">
          <InputGroup className="compensation-merit-input">
            <Form.Control
              type="number"
              step="0.01"
              value={merit}
              aria-label={t('applyMerit')}
              onChange={(event) => setMerit(event.target.value)}
            />
            <InputGroup.Text>%</InputGroup.Text>
          </InputGroup>
          <Button
            variant="outline-primary"
            label={t('applyToAll')}
            disabled={merit === ''}
            onClick={() => onApplyMeritToAll(Number(merit) || 0)}
          />
        </div>
        <div className="text-muted small mt-2">{t('applyMeritHint')}</div>
      </Card.Body>
    </Card>
  );
};
